import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const Birthday4 = () => {
    const navigate = useNavigate();
    const cursorRef = useRef(null);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = useState(false);

    // Doğum günü tarihi - 15 Eylül 2025 Pazartesi
    const [birthdayDate] = useState(new Date('2025-09-15T19:00:00'));

    // Geri sayım için state
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    const [showDetails, setShowDetails] = useState(false);
    const [activeSection, setActiveSection] = useState('');
    const [sparkles, setSparkles] = useState([]);
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    // Mouse takip efekti
    useEffect(() => {
        const handleMouseMove = (e) => {
            setMousePosition({ x: e.clientX, y: e.clientY });
        };

        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    // Sparkle animasyonu için
    useEffect(() => {
        const createSparkles = () => {
            const newSparkles = Array.from({ length: 15 }, (_, i) => ({
                id: i,
                left: Math.random() * 100,
                top: Math.random() * 100,
                delay: Math.random() * 3,
                duration: 2 + Math.random() * 2
            }));
            setSparkles(newSparkles);
        };

        createSparkles();
        const interval = setInterval(createSparkles, 5000);
        return () => clearInterval(interval);
    }, []);

    // Geri sayım timer'ı
    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = birthdayDate.getTime() - now;

            if (distance > 0) {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                setTimeLeft({ days, hours, minutes, seconds });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [birthdayDate]);

    const handleDetailToggle = () => {
        setShowDetails(!showDetails);
    };

    const toggleMusic = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-cream via-pearl to-soft-pink relative overflow-hidden">
            {/* Enhanced Custom Cursor */}
            <div
                className={`cursor-glow ${isHovering ? 'cursor-hover' : ''}`}
                style={{
                    left: mousePosition.x,
                    top: mousePosition.y,
                }}
            />

            {/* Floating Sparkles */}
            {sparkles.map((sparkle) => (
                <div
                    key={sparkle.id}
                    className="sparkle"
                    style={{
                        left: `${sparkle.left}%`,
                        top: `${sparkle.top}%`,
                        animationDelay: `${sparkle.delay}s`,
                        animationDuration: `${sparkle.duration}s`
                    }}
                >
                    ✨
                </div>
            ))}

            {/* Enhanced Background Elements */}
            <div className="absolute inset-0 pointer-events-none">
                {/* Large decorative circles */}
                <div className="absolute top-20 right-20 w-80 h-80 border-2 border-rose-gold/15 rounded-full animate-float-slow"></div>
                <div className="absolute bottom-32 left-16 w-40 h-40 border border-rose-gold/20 transform rotate-45 animate-rotate-slow"></div>

                {/* Floating hearts */}
                <div className="absolute top-1/4 left-1/5 text-rose-gold/30 text-2xl animate-float-heart">💕</div>
                <div className="absolute top-3/4 right-1/4 text-rose-gold/25 text-xl animate-float-heart-delayed">🌸</div>
                <div className="absolute top-1/2 right-1/6 text-rose-gold/20 text-lg animate-float-heart-slow">🦋</div>

                {/* Gradient orbs */}
                <div className="absolute top-1/3 left-1/3 w-32 h-32 bg-gradient-to-br from-rose-gold/10 to-transparent rounded-full blur-xl animate-pulse-slow"></div>
                <div className="absolute bottom-1/4 right-1/3 w-24 h-24 bg-gradient-to-br from-soft-pink/20 to-transparent rounded-full blur-lg animate-bounce-gentle"></div>

                {/* Decorative lines */}
                <div className="absolute top-1/3 right-1/3 w-1 h-24 bg-gradient-to-b from-rose-gold/15 to-transparent transform rotate-12 animate-fade-pulse"></div>
                <div className="absolute bottom-1/3 left-1/4 w-16 h-1 bg-gradient-to-r from-rose-gold/15 to-transparent transform -rotate-12 animate-fade-pulse"></div>
            </div>

            {/* Geri Dön Butonu */}
            <button
                onClick={() => navigate('/calismalarimiz')}
                className="fixed top-8 left-8 z-50 group"
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                aria-label="Çalışmalarımıza Geri Dön"
            >
                <div className="bg-white/90 backdrop-blur-xl text-warm-gray p-4 rounded-2xl shadow-elegant hover:shadow-elegant-hover transition-all duration-500 border border-rose-gold/30 group-hover:border-rose-gold/50">
                    <svg className="w-5 h-5 transform group-hover:-translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                </div>
            </button>

            {/* Ana Container */}
            <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-8 py-16">

                {/* Enhanced Header Section */}
                <div className="text-center mb-20 animate-fade-in-elegant">
                    <div className="relative">
                        {/* Enhanced Modern Header Card */}
                        <div className="header-main-card">
                            {/* Background pattern overlay */}
                            <div className="card-pattern-overlay"></div>

                            {/* Top decorative border */}
                            <div className="card-top-border"></div>

                            {/* Enhanced floating decorative elements */}
                            <div className="header-decoration header-decoration-1">🌸</div>
                            <div className="header-decoration header-decoration-2">✨</div>
                            <div className="header-decoration header-decoration-3">🎀</div>
                            <div className="header-decoration header-decoration-4">💫</div>
                            <div className="header-decoration header-decoration-5">🦋</div>
                            <div className="header-decoration header-decoration-6">💝</div>

                            {/* Modern gradient divider */}
                            <div className="gradient-divider gradient-divider-top"></div>

                            {/* Enhanced name section with backdrop */}
                            <div className="name-section">
                                <div className="name-backdrop">
                                    <h1 className="main-name" data-text="Ayşe">
                                        <span className="name-highlight">Ayşe</span>
                                    </h1>
                                    <div className="name-underline"></div>
                                </div>

                                <div className="age-container">
                                    <div className="age-wrapper">
                                        <div className="age-number-container">
                                            <span className="age-number-new">25</span>
                                            <div className="age-glow"></div>
                                        </div>
                                        <div className="age-text">
                                            <span className="age-label">yaşında</span>
                                            <span className="birthday-label">🎂 Birthday Queen</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Modern gradient divider */}
                            <div className="gradient-divider gradient-divider-middle"></div>

                            {/* Enhanced celebration badges */}
                            <div className="celebration-badges">
                                <div className="badge badge-primary">
                                    <div className="badge-glow"></div>
                                    <span className="badge-icon">👑</span>
                                    <span>Zarif Kutlama</span>
                                    <div className="badge-shimmer"></div>
                                </div>
                                <div className="badge badge-secondary">
                                    <div className="badge-glow"></div>
                                    <span className="badge-icon">🥂</span>
                                    <span>Özel Gece</span>
                                    <div className="badge-shimmer"></div>
                                </div>
                            </div>

                            {/* Modern gradient divider */}
                            <div className="gradient-divider gradient-divider-bottom"></div>

                            {/* Enhanced music player section */}
                            <div className="music-player-section">
                                <div className="music-player-label">
                                    <span className="music-label-icon">🎵</span>
                                    <span className="music-label-text">Özel Müziğimiz</span>
                                </div>

                                <button
                                    className="profile-circle profile-circle-bottom music-player-btn"
                                    onClick={toggleMusic}
                                    onMouseEnter={() => setIsHovering(true)}
                                    onMouseLeave={() => setIsHovering(false)}
                                    aria-label={isPlaying ? "Müziği Durdur" : "Müziği Başlat"}
                                >
                                    <div className="player-glow-ring"></div>
                                    <div className="profile-inner">
                                        <div className="music-icon">
                                            {isPlaying ? (
                                                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
                                                </svg>
                                            ) : (
                                                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M8 5v14l11-7z" />
                                                </svg>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`music-waves ${isPlaying ? 'playing' : ''}`}>
                                        <div className="wave wave-1"></div>
                                        <div className="wave wave-2"></div>
                                        <div className="wave wave-3"></div>
                                    </div>
                                </button>

                                <div className="music-status">
                                    <span className={`status-indicator ${isPlaying ? 'playing' : 'paused'}`}>
                                        {isPlaying ? '🎶 Çalıyor' : '⏸️ Duraklatıldı'}
                                    </span>
                                </div>
                            </div>

                            {/* Hidden audio element */}
                            <audio
                                ref={audioRef}
                                loop
                                onEnded={() => setIsPlaying(false)}
                                onPause={() => setIsPlaying(false)}
                                onPlay={() => setIsPlaying(true)}
                            >
                                <source src="/src/assets/wedding2music.mp3" type="audio/mpeg" />
                                Tarayıcınız ses dosyasını desteklemiyor.
                            </audio>

                            {/* Enhanced bottom wave with particles */}
                            <div className="header-wave">
                                <div className="wave-particles">
                                    <div className="particle particle-1"></div>
                                    <div className="particle particle-2"></div>
                                    <div className="particle particle-3"></div>
                                    <div className="particle particle-4"></div>
                                </div>
                                <svg viewBox="0 0 400 40" className="wave-svg">
                                    <path d="M0,20 Q100,0 200,20 T400,20 V40 H0 V20 Z" fill="url(#enhancedWaveGradient)" />
                                    <defs>
                                        <linearGradient id="enhancedWaveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                            <stop offset="0%" stopColor="rgba(232, 180, 166, 0.4)" />
                                            <stop offset="25%" stopColor="rgba(232, 180, 166, 0.6)" />
                                            <stop offset="50%" stopColor="rgba(232, 180, 166, 0.8)" />
                                            <stop offset="75%" stopColor="rgba(232, 180, 166, 0.6)" />
                                            <stop offset="100%" stopColor="rgba(232, 180, 166, 0.4)" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>

                            {/* Card corner decorations */}
                            <div className="corner-decoration corner-top-left"></div>
                            <div className="corner-decoration corner-top-right"></div>
                            <div className="corner-decoration corner-bottom-left"></div>
                            <div className="corner-decoration corner-bottom-right"></div>
                        </div>

                        {/* Floating invitation text */}
                        <div className="invitation-card">
                            <div className="invitation-content">
                                <div className="invitation-icon">💌</div>
                                <p className="invitation-text">
                                    <span className="invitation-main">Yeni yaşımı kutlamak için sizlerle bir araya gelmek istiyorum</span>
                                    <span className="invitation-sub">Bu özel anı birlikte paylaşalım ve unutulmaz anılar yaşayalım</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Enhanced Countdown Section */}
                <div className="mb-20 animate-fade-in-elegant" style={{ animationDelay: '0.3s' }}>
                    <div className="countdown-wrapper">
                        <h3 className="countdown-label">
                            <span className="countdown-emoji">⏰</span>
                            Kutlamaya Kalan Süre
                            <span className="countdown-emoji">⏰</span>
                        </h3>
                        <div className="countdown-container">
                            {[
                                { value: timeLeft.days, label: 'gün', emoji: '📅' },
                                { value: timeLeft.hours, label: 'saat', emoji: '🕐' },
                                { value: timeLeft.minutes, label: 'dakika', emoji: '⏱️' },
                                { value: timeLeft.seconds, label: 'saniye', emoji: '⚡' }
                            ].map((item, index) => (
                                <div key={index} className="countdown-item">
                                    <div className="countdown-card">
                                        <div className="countdown-emoji-top">{item.emoji}</div>
                                        <div className="countdown-number">
                                            {String(item.value).padStart(2, '0')}
                                        </div>
                                        <div className="countdown-unit">
                                            {item.label}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Enhanced Event Details Toggle */}
                <div className="mb-16 animate-fade-in-elegant" style={{ animationDelay: '0.6s' }}>
                    <button
                        onClick={handleDetailToggle}
                        onMouseEnter={() => setIsHovering(true)}
                        onMouseLeave={() => setIsHovering(false)}
                        className="details-toggle"
                    >
                        <span className="toggle-icon">🎊</span>
                        <span>Detayları Keşfet</span>
                        <div className={`toggle-arrow ${showDetails ? 'rotate-180' : ''}`}>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </button>
                </div>

                {/* Enhanced Event Details */}
                <div className={`details-container ${showDetails ? 'show' : ''}`}>
                    <div className="details-grid">
                        <div
                            className="detail-card"
                            onMouseEnter={() => setActiveSection('date')}
                            onMouseLeave={() => setActiveSection('')}
                        >
                            <div className="detail-header">
                                <div className="detail-icon">
                                    📅
                                </div>
                                <h4 className="detail-title">Tarih & Saat</h4>
                            </div>
                            <div className="detail-content">
                                <p className="detail-text">15 Eylül 2025</p>
                                <p className="detail-subtext">Pazartesi, 19:00</p>
                            </div>
                            <div className={`detail-expand ${activeSection === 'date' ? 'show' : ''}`}>
                                <p>✨ Akşam yemeği ile birlikte samimi bir kutlama</p>
                            </div>
                        </div>

                        <div
                            className="detail-card"
                            onMouseEnter={() => setActiveSection('location')}
                            onMouseLeave={() => setActiveSection('')}
                        >
                            <div className="detail-header">
                                <div className="detail-icon">
                                    📍
                                </div>
                                <h4 className="detail-title">Mekan</h4>
                            </div>
                            <div className="detail-content">
                                <p className="detail-text">Serafina Restaurant</p>
                                <p className="detail-subtext">Nişantaşı, İstanbul</p>
                            </div>
                            <div className={`detail-expand ${activeSection === 'location' ? 'show' : ''}`}>
                                <p>🏙️ Şehrin kalbinde zarif bir akşam yemeği</p>
                            </div>
                        </div>

                        <div
                            className="detail-card"
                            onMouseEnter={() => setActiveSection('dress')}
                            onMouseLeave={() => setActiveSection('')}
                        >
                            <div className="detail-header">
                                <div className="detail-icon">
                                    👗
                                </div>
                                <h4 className="detail-title">Dress Code</h4>
                            </div>
                            <div className="detail-content">
                                <p className="detail-text">Smart Casual</p>
                                <p className="detail-subtext">Şık ve rahat</p>
                            </div>
                            <div className={`detail-expand ${activeSection === 'dress' ? 'show' : ''}`}>
                                <p>💫 Sofistike ama rahat bir giyim tarzı</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Enhanced Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-6 mt-16 animate-fade-in-elegant" style={{ animationDelay: '0.9s' }}>
                    <a
                        href="https://www.google.com/maps/dir/?api=1&destination=Serafina+Restaurant,Nişantaşı,İstanbul"
                        target="_blank"
                        rel="noopener noreferrer"
                        onMouseEnter={() => setIsHovering(true)}
                        onMouseLeave={() => setIsHovering(false)}
                        className="action-btn action-btn-primary"
                    >
                        <span className="btn-icon">📍</span>
                        <span>Konum</span>
                    </a>
                    <button
                        onMouseEnter={() => setIsHovering(true)}
                        onMouseLeave={() => setIsHovering(false)}
                        className="action-btn action-btn-secondary"
                    >
                        <span className="btn-icon">💌</span>
                        <span>RSVP</span>
                    </button>
                </div>

                {/* Enhanced Footer */}
                <div className="mt-20 text-center animate-fade-in-elegant" style={{ animationDelay: '1.2s' }}>
                    <div className="footer-decoration">
                        <div className="footer-line"></div>
                        <span className="footer-heart">💝</span>
                        <div className="footer-line"></div>
                    </div>
                    <p className="footer-text">
                        Sizlerle geçireceğim bu özel akşamı dört gözle bekliyorum
                    </p>
                    <div className="mt-6 signature">
                        <div className="signature-text">Sevgiyle</div>
                        <div className="signature-name">Ayşe</div>
                    </div>
                    <div className="mt-4 brand-footer">
                        <span className="brand-emoji">✨</span>
                        DigiVite • 2025
                        <span className="brand-emoji">✨</span>
                    </div>
                </div>
            </div>

            {/* Enhanced Custom Styles */}
            <style jsx>{`
                @import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;500;600;700&family=Poppins:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Great+Vibes&display=swap');
                
                :root {
                    --cream: #fefcf8;
                    --pearl: #f8f6f3;
                    --soft-pink: #faf7f5;
                    --rose-gold: #e8b4a6;
                    --warm-gray: #6b5b73;
                    --warm-gray-light: #8a7a87;
                    --accent-pink: #f4e4e1;
                    --text-dark: #4a4a4a;
                }

                .bg-cream { background-color: var(--cream); }
                .bg-pearl { background-color: var(--pearl); }
                .bg-soft-pink { background-color: var(--soft-pink); }
                .text-warm-gray { color: var(--warm-gray); }
                .text-warm-gray-light { color: var(--warm-gray-light); }
                .border-rose-gold { border-color: var(--rose-gold); }

                .cursor-glow {
                    position: fixed;
                    width: 24px;
                    height: 24px;
                    background: radial-gradient(circle, rgba(232, 180, 166, 0.4) 0%, rgba(244, 228, 225, 0.2) 50%, transparent 70%);
                    border-radius: 50%;
                    pointer-events: none;
                    z-index: 9999;
                    transition: all 0.3s ease;
                    transform: translate(-50%, -50%);
                }

                .cursor-hover {
                    width: 48px;
                    height: 48px;
                    background: radial-gradient(circle, rgba(232, 180, 166, 0.3) 0%, rgba(244, 228, 225, 0.15) 50%, transparent 70%);
                }

                .sparkle {
                    position: absolute;
                    font-size: 12px;
                    animation: sparkle-float 3s infinite ease-in-out;
                    pointer-events: none;
                    opacity: 0.7;
                }

                .shadow-elegant {
                    box-shadow: 0 10px 40px rgba(107, 91, 115, 0.15);
                }

                .shadow-elegant-hover {
                    box-shadow: 0 15px 60px rgba(107, 91, 115, 0.25);
                }

                @keyframes sparkle-float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); opacity: 0.7; }
                    50% { transform: translateY(-20px) rotate(180deg); opacity: 1; }
                }

                @keyframes fade-in-elegant {
                    from {
                        opacity: 0;
                        transform: translateY(50px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes float-slow {
                    0%, 100% { transform: translateY(0px) scale(1); }
                    50% { transform: translateY(-25px) scale(1.02); }
                }

                @keyframes float-heart {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-15px) rotate(5deg); }
                }

                @keyframes float-heart-delayed {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-10px) rotate(-3deg); }
                }

                @keyframes float-heart-slow {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-8px) rotate(2deg); }
                }

                @keyframes rotate-slow {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }

                @keyframes glow-soft {
                    0%, 100% { box-shadow: 0 0 20px rgba(232, 180, 166, 0.2); }
                    50% { box-shadow: 0 0 30px rgba(232, 180, 166, 0.4); }
                }

                @keyframes pulse-slow {
                    0%, 100% { opacity: 0.5; transform: scale(1); }
                    50% { opacity: 0.8; transform: scale(1.1); }
                }

                @keyframes bounce-gentle {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-10px); }
                }

                @keyframes fade-pulse {
                    0%, 100% { opacity: 0.1; }
                    50% { opacity: 0.3; }
                }

                .animate-fade-in-elegant {
                    animation: fade-in-elegant 1.2s ease-out forwards;
                }

                .animate-float-slow {
                    animation: float-slow 10s ease-in-out infinite;
                }

                .animate-float-heart {
                    animation: float-heart 6s ease-in-out infinite;
                }

                .animate-float-heart-delayed {
                    animation: float-heart-delayed 7s ease-in-out infinite 2s;
                }

                .animate-float-heart-slow {
                    animation: float-heart-slow 8s ease-in-out infinite 1s;
                }

                .animate-rotate-slow {
                    animation: rotate-slow 25s linear infinite;
                }

                .animate-glow-soft {
                    animation: glow-soft 4s ease-in-out infinite;
                }

                .animate-pulse-slow {
                    animation: pulse-slow 4s ease-in-out infinite;
                }

                .animate-bounce-gentle {
                    animation: bounce-gentle 3s ease-in-out infinite;
                }

                .animate-fade-pulse {
                    animation: fade-pulse 3s ease-in-out infinite;
                }

                .header-main-card {
                    position: relative;
                    background: linear-gradient(145deg, rgba(255,255,255,0.98), rgba(248,246,243,0.95));
                    backdrop-filter: blur(25px);
                    border-radius: 3rem;
                    padding: 4rem 2.5rem 2rem;
                    border: 3px solid transparent;
                    background-clip: padding-box;
                    box-shadow: 
                        0 25px 80px rgba(107, 91, 115, 0.2),
                        0 10px 40px rgba(232, 180, 166, 0.15),
                        inset 0 1px 0 rgba(255,255,255,0.8);
                    overflow: hidden;
                    margin-bottom: 3rem;
                    transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                    max-width: 550px;
                    margin-left: auto;
                    margin-right: auto;
                }

                .header-main-card::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    padding: 3px;
                    background: linear-gradient(45deg, 
                        rgba(232, 180, 166, 0.6),
                        rgba(244, 228, 225, 0.4),
                        rgba(232, 180, 166, 0.8),
                        rgba(244, 228, 225, 0.3));
                    border-radius: inherit;
                    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
                    mask-composite: xor;
                    -webkit-mask-composite: xor;
                }

                .header-main-card:hover {
                    transform: translateY(-8px) scale(1.02);
                    box-shadow: 
                        0 35px 100px rgba(107, 91, 115, 0.25),
                        0 15px 60px rgba(232, 180, 166, 0.25),
                        inset 0 1px 0 rgba(255,255,255,0.9);
                }

                .card-pattern-overlay {
                    position: absolute;
                    inset: 0;
                    background: 
                        radial-gradient(circle at 20% 20%, rgba(232, 180, 166, 0.05) 0%, transparent 50%),
                        radial-gradient(circle at 80% 80%, rgba(244, 228, 225, 0.05) 0%, transparent 50%),
                        radial-gradient(circle at 40% 60%, rgba(232, 180, 166, 0.03) 0%, transparent 50%);
                    border-radius: inherit;
                    pointer-events: none;
                }

                .card-top-border {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 60%;
                    height: 4px;
                    background: linear-gradient(90deg, 
                        transparent, 
                        rgba(232, 180, 166, 0.6),
                        rgba(232, 180, 166, 0.8),
                        rgba(232, 180, 166, 0.6),
                        transparent);
                    border-radius: 0 0 2px 2px;
                }

                .gradient-divider {
                    height: 2px;
                    background: linear-gradient(90deg,
                        transparent,
                        rgba(232, 180, 166, 0.3),
                        rgba(232, 180, 166, 0.6),
                        rgba(232, 180, 166, 0.3),
                        transparent);
                    margin: 2rem 0;
                    position: relative;
                }

                .gradient-divider::before {
                    content: '';
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: 8px;
                    height: 8px;
                    background: var(--rose-gold);
                    border-radius: 50%;
                    box-shadow: 0 0 10px rgba(232, 180, 166, 0.5);
                }

                .corner-decoration {
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    border: 2px solid rgba(232, 180, 166, 0.4);
                }

                .corner-top-left {
                    top: 1rem;
                    left: 1rem;
                    border-right: none;
                    border-bottom: none;
                    border-radius: 12px 0 0 0;
                }

                .corner-top-right {
                    top: 1rem;
                    right: 1rem;
                    border-left: none;
                    border-bottom: none;
                    border-radius: 0 12px 0 0;
                }

                .corner-bottom-left {
                    bottom: 1rem;
                    left: 1rem;
                    border-right: none;
                    border-top: none;
                    border-radius: 0 0 0 12px;
                }

                .corner-bottom-right {
                    bottom: 1rem;
                    right: 1rem;
                    border-left: none;
                    border-top: none;
                    border-radius: 0 0 12px 0;
                }

                .header-decoration {
                    position: absolute;
                    font-size: 1.5rem;
                    animation: float-decoration 4s ease-in-out infinite;
                    opacity: 0.8;
                }

                .header-decoration-1 {
                    top: 1rem;
                    left: 1.5rem;
                    animation-delay: 0s;
                }

                .header-decoration-2 {
                    top: 1rem;
                    right: 1.5rem;
                    animation-delay: 1s;
                }

                .header-decoration-3 {
                    bottom: 4rem;
                    left: 1rem;
                    animation-delay: 2s;
                }

                .header-decoration-4 {
                    bottom: 4rem;
                    right: 1rem;
                    animation-delay: 3s;
                }

                .header-decoration-5 {
                    top: 50%;
                    left: 1rem;
                    animation-delay: 0.5s;
                }

                .header-decoration-6 {
                    top: 50%;
                    right: 1rem;
                    animation-delay: 2.5s;
                }

                @keyframes float-decoration {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-10px) rotate(5deg); }
                }

                .profile-circle {
                    width: 120px;
                    height: 120px;
                    background: linear-gradient(135deg, var(--rose-gold), #d4a994, #f4e4e1);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 2rem;
                    position: relative;
                    animation: profile-glow 3s ease-in-out infinite;
                }

                .profile-circle-bottom {
                    margin: 2rem auto 0;
                    position: relative;
                    z-index: 2;
                }

                @keyframes profile-glow {
                    0%, 100% { box-shadow: 0 0 20px rgba(232, 180, 166, 0.4); }
                    50% { box-shadow: 0 0 40px rgba(232, 180, 166, 0.8), 0 0 60px rgba(232, 180, 166, 0.4); }
                }

                .profile-inner {
                    width: 100px;
                    height: 100px;
                    background: linear-gradient(145deg, rgba(255,255,255,0.9), rgba(248,246,243,0.8));
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    backdrop-filter: blur(10px);
                }

                .profile-initials {
                    font-family: 'Great Vibes', cursive;
                    font-size: 3rem;
                    color: var(--rose-gold);
                    text-shadow: 2px 2px 10px rgba(232, 180, 166, 0.4);
                }

                .music-player-btn {
                    border: none;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: visible;
                }

                .music-player-btn:hover {
                    transform: translateY(-3px) scale(1.05);
                }

                .music-icon {
                    color: var(--rose-gold);
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .music-player-btn:hover .music-icon {
                    color: var(--warm-gray);
                    transform: scale(1.1);
                }

                .music-waves {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 140px;
                    height: 140px;
                    pointer-events: none;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }

                .music-waves.playing {
                    opacity: 1;
                }

                .wave {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    border: 2px solid var(--rose-gold);
                    border-radius: 50%;
                    opacity: 0;
                }

                .wave-1 {
                    width: 130px;
                    height: 130px;
                    animation: wave-pulse 2s ease-out infinite;
                }

                .wave-2 {
                    width: 150px;
                    height: 150px;
                    animation: wave-pulse 2s ease-out infinite 0.5s;
                }

                .wave-3 {
                    width: 170px;
                    height: 170px;
                    animation: wave-pulse 2s ease-out infinite 1s;
                }

                @keyframes wave-pulse {
                    0% {
                        opacity: 1;
                        transform: translate(-50%, -50%) scale(0.8);
                    }
                    50% {
                        opacity: 0.6;
                        transform: translate(-50%, -50%) scale(1);
                    }
                    100% {
                        opacity: 0;
                        transform: translate(-50%, -50%) scale(1.2);
                    }
                }

                .name-section {
                    text-align: center;
                    margin-bottom: 2rem;
                    margin-top: 1rem;
                    position: relative;
                }

                .name-backdrop {
                    position: relative;
                    display: inline-block;
                    padding: 1.5rem 3.5rem;
                    background: linear-gradient(135deg, 
                        rgba(255,255,255,0.95), 
                        rgba(248,246,243,0.85));
                    border-radius: 2rem;
                    backdrop-filter: blur(15px);
                    border: 2px solid rgba(232, 180, 166, 0.4);
                    margin-bottom: 1.5rem;
                    box-shadow: 
                        0 8px 32px rgba(107, 91, 115, 0.1),
                        inset 0 1px 0 rgba(255,255,255,0.8);
                    min-width: fit-content;
                    overflow: visible;
                }

                .name-highlight {
                    position: relative;
                    display: inline-block;
                    color: var(--warm-gray);
                    background: linear-gradient(135deg, 
                        var(--warm-gray), 
                        var(--rose-gold), 
                        #d4a994);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    filter: contrast(1.2) saturate(1.1);
                    overflow: visible;
                    white-space: nowrap;
                    padding: 0 0.5rem;
                }

                /* Fallback for browsers that don't support background-clip */
                @supports not (-webkit-background-clip: text) {
                    .name-highlight {
                        color: var(--warm-gray);
                        background: none;
                        -webkit-text-fill-color: initial;
                    }
                }

                .name-underline {
                    position: absolute;
                    bottom: -5px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 80%;
                    height: 3px;
                    background: linear-gradient(90deg, 
                        transparent,
                        var(--rose-gold),
                        transparent);
                    border-radius: 2px;
                    animation: underline-glow 3s ease-in-out infinite;
                }

                @keyframes underline-glow {
                    0%, 100% { opacity: 0.6; transform: translateX(-50%) scaleX(0.8); }
                    50% { opacity: 1; transform: translateX(-50%) scaleX(1.1); }
                }

                .age-number-container {
                    position: relative;
                    display: inline-block;
                }

                .age-glow {
                    position: absolute;
                    inset: -10px;
                    background: radial-gradient(circle, rgba(232, 180, 166, 0.3) 0%, transparent 70%);
                    border-radius: 50%;
                    animation: age-pulse 2s ease-in-out infinite;
                    pointer-events: none;
                }

                @keyframes age-pulse {
                    0%, 100% { opacity: 0.5; transform: scale(0.9); }
                    50% { opacity: 0.8; transform: scale(1.1); }
                }

                .main-name {
                    font-family: 'Great Vibes', cursive;
                    font-size: clamp(3rem, 8vw, 5rem);
                    margin-bottom: 1rem;
                    text-shadow: 3px 3px 20px rgba(107, 91, 115, 0.4);
                    background: linear-gradient(135deg, 
                        var(--warm-gray), 
                        var(--rose-gold), 
                        #d4a994);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    position: relative;
                    overflow: visible;
                    white-space: nowrap;
                    width: 100%;
                    text-align: center;
                }

                .main-name::before {
                    content: attr(data-text);
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: -1;
                    color: rgba(107, 91, 115, 0.8);
                    text-shadow: none;
                }

                .age-container {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 1rem;
                }

                .age-wrapper {
                    background: linear-gradient(135deg, rgba(232, 180, 166, 0.2), rgba(244, 228, 225, 0.3));
                    border-radius: 2rem;
                    padding: 1rem 2rem;
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    border: 1px solid rgba(232, 180, 166, 0.3);
                    backdrop-filter: blur(10px);
                }

                .age-number-new {
                    font-family: 'Dancing Script', cursive;
                    font-size: 3.5rem;
                    font-weight: 700;
                    color: var(--rose-gold);
                    text-shadow: 2px 2px 10px rgba(232, 180, 166, 0.4);
                    line-height: 1;
                }

                .age-text {
                    display: flex;
                    flex-direction: column;
                    gap: 0.25rem;
                }

                .age-label {
                    font-family: 'Poppins', sans-serif;
                    font-size: 1.25rem;
                    color: var(--warm-gray);
                    font-weight: 500;
                }

                .birthday-label {
                    font-family: 'Poppins', sans-serif;
                    font-size: 0.9rem;
                    color: var(--rose-gold);
                    font-weight: 600;
                    font-style: italic;
                }

                .celebration-badges {
                    display: flex;
                    justify-content: center;
                    gap: 1rem;
                    margin-bottom: 2rem;
                    flex-wrap: wrap;
                }

                .badge {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 0.75rem 1.5rem;
                    border-radius: 2rem;
                    font-family: 'Poppins', sans-serif;
                    font-size: 0.9rem;
                    font-weight: 500;
                    transition: all 0.3s ease;
                    backdrop-filter: blur(10px);
                }

                .badge-primary {
                    background: linear-gradient(135deg, var(--rose-gold), #d4a994);
                    color: white;
                    border: 1px solid rgba(232, 180, 166, 0.4);
                    box-shadow: 0 4px 15px rgba(232, 180, 166, 0.3);
                }

                .badge-secondary {
                    background: linear-gradient(135deg, rgba(255,255,255,0.8), rgba(248,246,243,0.7));
                    color: var(--warm-gray);
                    border: 1px solid rgba(232, 180, 166, 0.3);
                    box-shadow: 0 4px 15px rgba(107, 91, 115, 0.1);
                }

                .badge {
                    position: relative;
                    overflow: hidden;
                }

                .badge:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(232, 180, 166, 0.4);
                }

                .badge-glow {
                    position: absolute;
                    inset: 0;
                    background: linear-gradient(45deg, 
                        rgba(232, 180, 166, 0.1),
                        rgba(244, 228, 225, 0.1));
                    border-radius: inherit;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }

                .badge:hover .badge-glow {
                    opacity: 1;
                }

                .badge-shimmer {
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, 
                        transparent, 
                        rgba(255,255,255,0.4), 
                        transparent);
                    transition: left 0.6s ease;
                }

                .badge:hover .badge-shimmer {
                    left: 100%;
                }

                .music-player-section {
                    text-align: center;
                    margin-top: 1rem;
                }

                .music-player-label {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.5rem;
                    margin-bottom: 1rem;
                    font-family: 'Poppins', sans-serif;
                    font-size: 0.9rem;
                    color: var(--warm-gray-light);
                    font-weight: 500;
                }

                .music-label-icon {
                    font-size: 1.1rem;
                    animation: music-note-bounce 2s ease-in-out infinite;
                }

                @keyframes music-note-bounce {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-3px); }
                }

                .player-glow-ring {
                    position: absolute;
                    inset: -8px;
                    border: 2px solid transparent;
                    border-radius: 50%;
                    background: linear-gradient(45deg, 
                        rgba(232, 180, 166, 0.4),
                        rgba(244, 228, 225, 0.2),
                        rgba(232, 180, 166, 0.6)) border-box;
                    mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
                    mask-composite: xor;
                    -webkit-mask-composite: xor;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                    animation: ring-rotate 4s linear infinite;
                }

                .music-player-btn:hover .player-glow-ring {
                    opacity: 1;
                }

                @keyframes ring-rotate {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }

                .music-status {
                    margin-top: 1rem;
                    font-family: 'Poppins', sans-serif;
                    font-size: 0.8rem;
                }

                .status-indicator {
                    padding: 0.5rem 1rem;
                    border-radius: 1.5rem;
                    font-weight: 500;
                    transition: all 0.3s ease;
                }

                .status-indicator.playing {
                    background: linear-gradient(135deg, 
                        rgba(34, 197, 94, 0.2),
                        rgba(34, 197, 94, 0.1));
                    color: rgb(34, 197, 94);
                    border: 1px solid rgba(34, 197, 94, 0.3);
                }

                .status-indicator.paused {
                    background: linear-gradient(135deg, 
                        rgba(156, 163, 175, 0.2),
                        rgba(156, 163, 175, 0.1));
                    color: rgb(156, 163, 175);
                    border: 1px solid rgba(156, 163, 175, 0.3);
                }

                .badge-icon {
                    font-size: 1.1rem;
                }

                .header-wave {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 40px;
                    overflow: hidden;
                }

                .wave-svg {
                    width: 100%;
                    height: 100%;
                }

                .wave-particles {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 40px;
                    pointer-events: none;
                }

                .particle {
                    position: absolute;
                    width: 4px;
                    height: 4px;
                    background: var(--rose-gold);
                    border-radius: 50%;
                    opacity: 0.6;
                }

                .particle-1 {
                    left: 10%;
                    animation: particle-float-1 6s ease-in-out infinite;
                }

                .particle-2 {
                    left: 30%;
                    animation: particle-float-2 5s ease-in-out infinite 1s;
                }

                .particle-3 {
                    left: 60%;
                    animation: particle-float-3 7s ease-in-out infinite 2s;
                }

                .particle-4 {
                    left: 85%;
                    animation: particle-float-4 4s ease-in-out infinite 0.5s;
                }

                @keyframes particle-float-1 {
                    0%, 100% { transform: translateY(30px); opacity: 0.3; }
                    50% { transform: translateY(5px); opacity: 0.8; }
                }

                @keyframes particle-float-2 {
                    0%, 100% { transform: translateY(25px); opacity: 0.4; }
                    50% { transform: translateY(0px); opacity: 0.9; }
                }

                @keyframes particle-float-3 {
                    0%, 100% { transform: translateY(35px); opacity: 0.2; }
                    50% { transform: translateY(8px); opacity: 0.7; }
                }

                @keyframes particle-float-4 {
                    0%, 100% { transform: translateY(20px); opacity: 0.5; }
                    50% { transform: translateY(3px); opacity: 1; }
                }

                .invitation-card {
                    background: linear-gradient(135deg, rgba(255,255,255,0.9), rgba(248,246,243,0.8));
                    backdrop-filter: blur(20px);
                    border-radius: 2rem;
                    padding: 2rem;
                    border: 1px solid rgba(232, 180, 166, 0.2);
                    box-shadow: 0 15px 50px rgba(107, 91, 115, 0.1);
                    position: relative;
                    overflow: hidden;
                    animation: invitation-float 6s ease-in-out infinite;
                }

                @keyframes invitation-float {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-8px); }
                }

                .invitation-content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    gap: 1.5rem;
                }

                .invitation-icon {
                    font-size: 2.5rem;
                    animation: invitation-pulse 2s ease-in-out infinite;
                }

                @keyframes invitation-pulse {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(1.1); }
                }

                .invitation-text {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    margin: 0;
                }

                .invitation-main {
                    font-family: 'Poppins', sans-serif;
                    font-size: 1.3rem;
                    font-weight: 500;
                    color: var(--text-dark);
                    line-height: 1.6;
                }

                .invitation-sub {
                    font-family: 'Poppins', sans-serif;
                    font-size: 1.1rem;
                    font-weight: 400;
                    color: var(--warm-gray-light);
                    font-style: italic;
                    line-height: 1.5;
                }

                .countdown-wrapper {
                    background: rgba(255, 255, 255, 0.6);
                    backdrop-filter: blur(15px);
                    border-radius: 2rem;
                    padding: 2.5rem;
                    border: 1px solid rgba(232, 180, 166, 0.2);
                    box-shadow: 0 8px 32px rgba(107, 91, 115, 0.1);
                }

                .countdown-label {
                    font-family: 'Poppins', sans-serif;
                    font-size: 1.25rem;
                    font-weight: 500;
                    color: var(--warm-gray);
                    text-align: center;
                    margin-bottom: 2.5rem;
                    letter-spacing: 0.05em;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.75rem;
                }

                .countdown-emoji {
                    font-size: 1.5rem;
                }

                .countdown-container {
                    display: flex;
                    gap: 2rem;
                    justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
                }

                .countdown-item {
                    text-align: center;
                }

                .countdown-card {
                    background: linear-gradient(145deg, rgba(255,255,255,0.9), rgba(248,246,243,0.8));
                    border-radius: 1.5rem;
                    padding: 1.5rem 1rem;
                    border: 1px solid rgba(232, 180, 166, 0.3);
                    backdrop-filter: blur(10px);
                    box-shadow: 0 4px 20px rgba(107, 91, 115, 0.1);
                    transition: all 0.3s ease;
                    min-width: 100px;
                }

                .countdown-card:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 8px 30px rgba(107, 91, 115, 0.15);
                }

                .countdown-emoji-top {
                    font-size: 1.5rem;
                    margin-bottom: 0.5rem;
                }

                .countdown-number {
                    font-family: 'Dancing Script', cursive;
                    font-size: 2.5rem;
                    font-weight: 600;
                    color: var(--warm-gray);
                    line-height: 1;
                    margin-bottom: 0.5rem;
                    text-shadow: 1px 1px 3px rgba(107, 91, 115, 0.2);
                }

                .countdown-unit {
                    font-family: 'Poppins', sans-serif;
                    font-size: 0.9rem;
                    font-weight: 400;
                    color: var(--warm-gray-light);
                    letter-spacing: 0.1em;
                    text-transform: lowercase;
                }

                .details-toggle {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    font-family: 'Poppins', sans-serif;
                    font-size: 1.1rem;
                    font-weight: 500;
                    color: var(--warm-gray);
                    background: linear-gradient(135deg, rgba(255,255,255,0.8), rgba(248,246,243,0.7));
                    backdrop-filter: blur(15px);
                    border: 1px solid rgba(232, 180, 166, 0.3);
                    padding: 1.25rem 2.5rem;
                    border-radius: 3rem;
                    transition: all 0.4s ease;
                    cursor: pointer;
                    box-shadow: 0 4px 20px rgba(107, 91, 115, 0.1);
                }

                .details-toggle:hover {
                    background: linear-gradient(135deg, rgba(255,255,255,0.95), rgba(248,246,243,0.85));
                    border-color: rgba(232, 180, 166, 0.5);
                    transform: translateY(-3px);
                    box-shadow: 0 8px 30px rgba(107, 91, 115, 0.15);
                }

                .toggle-icon {
                    font-size: 1.25rem;
                }

                .toggle-arrow {
                    transition: transform 0.3s ease;
                }

                .details-container {
                    max-height: 0;
                    overflow: hidden;
                    transition: max-height 0.8s ease;
                    width: 100%;
                    max-width: 56rem;
                }

                .details-container.show {
                    max-height: 800px;
                }

                .details-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
                    gap: 2rem;
                    margin-top: 3rem;
                }

                .detail-card {
                    background: linear-gradient(145deg, rgba(255,255,255,0.8), rgba(248,246,243,0.7));
                    backdrop-filter: blur(20px);
                    border: 1px solid rgba(232, 180, 166, 0.2);
                    border-radius: 1.5rem;
                    padding: 2rem;
                    transition: all 0.4s ease;
                    cursor: pointer;
                    position: relative;
                    overflow: hidden;
                    box-shadow: 0 4px 20px rgba(107, 91, 115, 0.1);
                }

                .detail-card:hover {
                    background: linear-gradient(145deg, rgba(255,255,255,0.95), rgba(248,246,243,0.85));
                    border-color: rgba(232, 180, 166, 0.4);
                    transform: translateY(-5px);
                    box-shadow: 0 12px 40px rgba(107, 91, 115, 0.2);
                }

                .detail-header {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    margin-bottom: 1.5rem;
                }

                .detail-icon {
                    font-size: 2rem;
                }

                .detail-title {
                    font-family: 'Dancing Script', cursive;
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: var(--warm-gray);
                    margin: 0;
                }

                .detail-content {
                    margin-left: 3rem;
                }

                .detail-text {
                    font-family: 'Poppins', sans-serif;
                    font-size: 1.1rem;
                    font-weight: 500;
                    color: var(--text-dark);
                    margin-bottom: 0.5rem;
                }

                .detail-subtext {
                    font-family: 'Poppins', sans-serif;
                    font-size: 0.95rem;
                    font-weight: 400;
                    color: var(--warm-gray-light);
                    font-style: italic;
                }

                .detail-expand {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: linear-gradient(to top, rgba(244, 228, 225, 0.95), rgba(244, 228, 225, 0.7));
                    padding: 1.5rem 2rem 1.25rem;
                    transform: translateY(100%);
                    transition: transform 0.4s ease;
                    backdrop-filter: blur(10px);
                }

                .detail-expand.show {
                    transform: translateY(0);
                }

                .detail-expand p {
                    font-family: 'Poppins', sans-serif;
                    font-size: 0.95rem;
                    font-style: italic;
                    color: var(--warm-gray);
                    margin: 0;
                    font-weight: 400;
                }

                .action-btn {
                    font-family: 'Poppins', sans-serif;
                    font-size: 1.1rem;
                    font-weight: 500;
                    padding: 1.25rem 2.5rem;
                    border-radius: 3rem;
                    transition: all 0.4s ease;
                    text-decoration: none;
                    border: none;
                    cursor: pointer;
                    letter-spacing: 0.02em;
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    min-width: 150px;
                    justify-content: center;
                }

                .action-btn-primary {
                    background: linear-gradient(135deg, var(--rose-gold), #d4a994);
                    color: white;
                    box-shadow: 0 8px 32px rgba(232, 180, 166, 0.4);
                    border: 1px solid rgba(232, 180, 166, 0.3);
                }

                .action-btn-primary:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 12px 48px rgba(232, 180, 166, 0.5);
                    background: linear-gradient(135deg, #d4a994, var(--rose-gold));
                }

                .action-btn-secondary {
                    background: linear-gradient(135deg, rgba(255,255,255,0.9), rgba(248,246,243,0.8));
                    color: var(--warm-gray);
                    border: 1px solid rgba(232, 180, 166, 0.4);
                    backdrop-filter: blur(15px);
                    box-shadow: 0 4px 20px rgba(107, 91, 115, 0.1);
                }

                .action-btn-secondary:hover {
                    background: linear-gradient(135deg, rgba(255,255,255,1), rgba(248,246,243,0.95));
                    border-color: rgba(232, 180, 166, 0.6);
                    transform: translateY(-4px);
                    box-shadow: 0 8px 30px rgba(107, 91, 115, 0.15);
                }

                .btn-icon {
                    font-size: 1.25rem;
                }

                .footer-decoration {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 1rem;
                    margin-bottom: 2rem;
                }

                .footer-line {
                    width: 3rem;
                    height: 1px;
                    background: linear-gradient(to right, transparent, var(--rose-gold), transparent);
                }

                .footer-heart {
                    font-size: 1.5rem;
                }

                .footer-text {
                    font-family: 'Poppins', sans-serif;
                    font-size: 1.1rem;
                    font-weight: 400;
                    color: var(--text-dark);
                    font-style: italic;
                    max-width: 28rem;
                    margin: 0 auto;
                    line-height: 1.7;
                }

                .signature {
                    background: rgba(255, 255, 255, 0.6);
                    backdrop-filter: blur(10px);
                    border-radius: 1.5rem;
                    padding: 1.5rem 2rem;
                    border: 1px solid rgba(232, 180, 166, 0.2);
                    display: inline-block;
                }

                .signature-text {
                    font-family: 'Poppins', sans-serif;
                    font-size: 0.9rem;
                    color: var(--warm-gray-light);
                    font-style: italic;
                    margin-bottom: 0.5rem;
                }

                .signature-name {
                    font-family: 'Great Vibes', cursive;
                    font-size: 2rem;
                    color: var(--rose-gold);
                    text-shadow: 1px 1px 5px rgba(232, 180, 166, 0.3);
                }

                .brand-footer {
                    font-family: 'Poppins', sans-serif;
                    font-size: 0.85rem;
                    color: var(--warm-gray-light);
                    opacity: 0.8;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.5rem;
                }

                .brand-emoji {
                    font-size: 1rem;
                }

                /* Responsive */
                @media (max-width: 768px) {
                    .header-main-card {
                        max-width: 90%;
                        padding: 2.5rem 1.5rem 1rem;
                        margin-bottom: 1.5rem;
                    }
                    
                    .profile-circle {
                        width: 100px;
                        height: 100px;
                    }
                    
                    .profile-circle-bottom {
                        margin: 1.5rem auto 0;
                    }
                    
                    .profile-inner {
                        width: 85px;
                        height: 85px;
                    }
                    
                    .profile-initials {
                        font-size: 2.5rem;
                    }
                    
                    .music-icon svg {
                        width: 2rem;
                        height: 2rem;
                    }
                    
                    .main-name {
                        font-size: clamp(2.5rem, 10vw, 4rem);
                    }
                    
                    .name-backdrop {
                        padding: 1.25rem 3rem;
                    }
                    
                    .age-number-new {
                        font-size: 3rem;
                    }
                    
                    .age-label {
                        font-size: 1.1rem;
                    }
                    
                    .birthday-label {
                        font-size: 0.8rem;
                    }
                    
                    .celebration-badges {
                        flex-direction: column;
                        align-items: center;
                        gap: 0.75rem;
                    }
                    
                    .badge {
                        font-size: 0.85rem;
                        padding: 0.6rem 1.25rem;
                    }
                    
                    .invitation-card {
                        padding: 1.5rem;
                    }
                    
                    .invitation-icon {
                        font-size: 2rem;
                    }
                    
                    .invitation-main {
                        font-size: 1.15rem;
                    }
                    
                    .invitation-sub {
                        font-size: 1rem;
                    }
                    
                    .countdown-container {
                        gap: 1rem;
                    }
                    
                    .countdown-number {
                        font-size: 2rem;
                    }
                    
                    .countdown-wrapper {
                        padding: 2rem 1.5rem;
                    }
                    
                    .details-grid {
                        grid-template-columns: 1fr;
                        gap: 1.5rem;
                    }
                    
                    .detail-card {
                        padding: 1.5rem;
                    }
                    
                    .detail-content {
                        margin-left: 2.5rem;
                    }
                }

                @media (max-width: 480px) {
                    .header-main-card {
                        max-width: 95%;
                        padding: 2rem 1rem 1rem;
                        border-radius: 2rem;
                    }
                    
                    .header-decoration {
                        font-size: 1.25rem;
                    }
                    
                    .profile-circle {
                        width: 80px;
                        height: 80px;
                    }
                    
                    .profile-circle-bottom {
                        margin: 1rem auto 0;
                    }
                    
                    .profile-inner {
                        width: 68px;
                        height: 68px;
                    }
                    
                    .profile-initials {
                        font-size: 2rem;
                    }
                    
                    .music-icon svg {
                        width: 1.5rem;
                        height: 1.5rem;
                    }
                    
                    .wave-1 {
                        width: 100px;
                        height: 100px;
                    }
                    
                    .wave-2 {
                        width: 120px;
                        height: 120px;
                    }
                    
                    .wave-3 {
                        width: 140px;
                        height: 140px;
                    }
                    
                    .main-name {
                        font-size: clamp(2rem, 12vw, 3rem);
                        margin-bottom: 0.75rem;
                    }
                    
                    .name-backdrop {
                        padding: 1rem 2.5rem;
                        min-width: 200px;
                    }
                    
                    .age-wrapper {
                        padding: 0.75rem 1.5rem;
                        gap: 0.75rem;
                    }
                    
                    .age-number-new {
                        font-size: 2.5rem;
                    }
                    
                    .age-label {
                        font-size: 1rem;
                    }
                    
                    .birthday-label {
                        font-size: 0.75rem;
                    }
                    
                    .badge {
                        font-size: 0.8rem;
                        padding: 0.5rem 1rem;
                    }
                    
                    .invitation-card {
                        padding: 1.25rem;
                        border-radius: 1.5rem;
                    }
                    
                    .invitation-content {
                        gap: 1rem;
                    }
                    
                    .invitation-icon {
                        font-size: 1.75rem;
                    }
                    
                    .invitation-main {
                        font-size: 1rem;
                    }
                    
                    .invitation-sub {
                        font-size: 0.9rem;
                    }
                    
                    .countdown-container {
                        gap: 0.75rem;
                    }
                    
                    .countdown-number {
                        font-size: 1.75rem;
                    }
                    
                    .countdown-unit {
                        font-size: 0.8rem;
                    }
                    
                    .countdown-card {
                        padding: 1.25rem 0.75rem;
                        min-width: 80px;
                    }
                    
                    .action-btn {
                        padding: 1rem 2rem;
                        font-size: 1rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default Birthday4; 